"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _NavProvider = require("../components/NavProvider");

/**
 * Exposes the nav context to a child component.
 * @package
 * @returns {object} Navbar context
 */
var useNavContext = function useNavContext() {
  var context = (0, _react.useContext)(_NavProvider.NavContext);
  return context;
};

var _default = useNavContext;
exports["default"] = _default;